import { Button } from "@xola/ui-kit";
import React, { ButtonHTMLAttributes, ReactNode } from "react";

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ReactNode;
    size?: string;
    onClick?: (...arguments_: any[]) => any;
    children: ReactNode;
}

export const SecondaryButton = ({
    type = "button",
    size = "medium",
    onClick,
    children,
    ...rest
}: SecondaryButtonProps) => (
    <Button type={type} variant="outline" color="secondary" size={size} onClick={onClick} {...rest}>
        {children}
    </Button>
);
